import { render, staticRenderFns } from "./BusinessNetworkRegistrantForm.vue?vue&type=template&id=1d44d52e"
import script from "./BusinessNetworkRegistrantForm.vue?vue&type=script&lang=js"
export * from "./BusinessNetworkRegistrantForm.vue?vue&type=script&lang=js"
import style0 from "./BusinessNetworkRegistrantForm.vue?vue&type=style&index=0&id=1d44d52e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports